// extracted by mini-css-extract-plugin
export default {"rating":"lR-z","numberOfStars":"mR-z","count":"nR-z","barGraphSpacing":"oR-z","barGraph":"pR-z"};